// ------------------------------------------------------------------------------
// name: tools
// author: mudas
// created: 2023/3/7
// ------------------------------------------------------------------------------

import { v4 as uuid } from 'uuid';
import { CommonListResponse } from 'common/types';
import { FastApiStatusCode } from 'common/service/constants/fastApi';

export type UsePaginationStyleData<T = any> = { total: number; list: T[] };

/**
 * 接口服务是否为执行成功 code
 * @param code
 */
export const isSuccessCode = (code?: number | string) => {
  const formated = +(code ?? NaN);
  return !Number.isNaN(formated) && [FastApiStatusCode.SuccessCode, 10000].includes(formated);
};

/**
 * 将 useQuery 风格的 data 转换为 useRequest 分页数据风格
 * - 主要是 items 和 list 字段的差异
 * @param value
 * @param generatorId 是否生成 id 字段，用于列表数据唯一性标识（仅在返回数据无唯一字段时使用）
 */
export const transformResponse = <T = any>(value: CommonListResponse<T>, generatorId?: string) => {
  const { total, items } = value || {};
  const data: UsePaginationStyleData<T> = { total: total, list: [] };

  if (Array.isArray(items)) {
    data.list = items?.map((item) => {
      if (!!generatorId) {
        item[generatorId] = uuid();
      }

      return item;
    });
  }

  return data;
};
